import React from 'react';
import { trackEPassPageEvent } from '../../utils/omnitureTracking';

type BookNowCardProps = {
  redirectToCabsPage: () => void;
  isMobileDevice: boolean;
};
const BookNowCard = ({
  redirectToCabsPage,
  isMobileDevice
}: BookNowCardProps) => {
  const onBookNowClick = () => {
    trackEPassPageEvent('Cab_SEO_Epass_Booknow_Click');
    redirectToCabsPage();
  };

  return (
    <section style={{ marginBottom: '0px' }} className="book__cab section__bdr">
      <div className="" style={{ display: 'flex' }}>
        <div className="epass__assistance dark__text ">
          <p className="section__heading latoBlack">
            <span>{`Booking a cab with e-Pass on MakeMyTrip`}</span>{' '}
          </p>
          <ul className="epass__req__list appendBottom20">
            <li>
              <p className="latoBold blackText title__text">
                Apply for e-Pass on govt sites
              </p>
              <p className="greyText desc__text">
                which is mandatory on selected routes.{' '}
                <a
                  className="latoBold capText knowMore"
                  onClick={() =>
                    trackEPassPageEvent('Cabs_SEO_Epass_Know_More_Click')
                  }
                >
                  Know More
                </a>
              </p>
            </li>
            <li>
              <p className="latoBold blackText title__text">
                Provide your Cab Details
              </p>
              <p className="greyText desc__text">
                that we will share with you, to apply for your e-Pass.
              </p>
            </li>
            <li>
              <p className="latoBold blackText title__text">
                Upload your e-Pass
              </p>
              <p className="greyText desc__text">
                on the link shared post booking, to avoid cancellation.
              </p>
            </li>
          </ul>
          <button
            className="epass__form__btn pushBottom"
            onClick={onBookNowClick}
          >
            {' '}
            Book Now
          </button>
        </div>
        {!isMobileDevice ? (
          <div className="book__cab__img pushRight">&nbsp;</div>
        ) : (
          ''
        )}
      </div>
    </section>
  );
};
export default BookNowCard;
